import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Note from '@shared/ui/messages/Note';

export default function SidebarEnableTwoFa() {
  const { user, isFrozen } = useSelector((state) => state.user);
  const { t } = useTranslation();

  if (user.two_fa || isFrozen) return null;

  return (
    <Note type="info" title="2FA" content={t('we_recomment_enable_2fa')}>
      <Link className="dashed-btn" to="/profile">
        {t('enable_2fa')}
      </Link>
    </Note>
  );
}
